import { useMutation } from '@tanstack/react-query';

import { ServiceProvider } from 'src/features/serviceProvider/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/service-provider/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    parkingId: string;
}

const mutationFn = ({parkingId, ...data}: DTO): Promise<ServiceProvider> => {
    return axios.post(formatResourcePath(RESOURCE, {parkingId}), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateServiceProvider };
